import { defineMessages } from 'react-intl'

export default defineMessages({
  galleryTitle: { id: 'portfolio.gallery.title', defaultMessage: 'Galerija' },
  mapTitle: { id: 'portfolio.map.title', defaultMessage: 'Karta' },
})
